<template>
  <div
    class="internal-bady"
    :class="{ 'after-first-attraction--en': pageLanguage === 'en' }"
    :dir="pageDirection"
    :lang="pageLanguage"
  >
    <WhatsappChet />
    <NavBar />
    <div id="top"></div>

    <section class="after-first-attraction-section px-3 px-md-4">
      <div class="container">
        <div class="after-first-attraction-success-wrap">
          <span class="after-first-attraction-success-icon"><i class="fa-solid fa-circle-check"></i></span>
          <p class="after-first-attraction-success mb-0">{{ t("afterFirstAttractionSuccess") }}</p>
        </div>
        <p class="after-first-attraction-subtitle">
          {{ t("afterFirstAttractionSubtitle") }}
        </p>

        <div class="after-first-attraction-options row g-4 mb-4">
          <div class="col-md-6">
            <div class="after-first-attraction-option-card">
              <h3 class="after-first-attraction-option-title">{{ t('afterFirstAttractionOption1Title') }}</h3>
              <p class="after-first-attraction-option-text mb-3">{{ t('afterFirstAttractionOption1Text') }}</p>
              <button
                type="button"
                class="btn btn-primary after-first-attraction-cta fw-semibold"
                @click="goToRide"
              >
                {{ t('afterFirstAttractionOption1Button') }}
              </button>
            </div>
          </div>
          <div class="col-md-6">
            <div class="after-first-attraction-option-card">
              <h3 class="after-first-attraction-option-title">{{ t('afterFirstAttractionOption2Title') }}</h3>
              <p class="after-first-attraction-option-text mb-3">{{ t('afterFirstAttractionOption2Text') }}</p>
              <button
                type="button"
                class="btn btn-outline-primary after-first-attraction-cta-outline fw-semibold"
                @click="goToRideAtTop"
              >
                {{ t('afterFirstAttractionOption2Button') }}
              </button>
            </div>
          </div>
        </div>

        <div class="after-first-attraction-help mb-4">
          <h4 class="after-first-attraction-help-heading">{{ t("afterFirstAttractionHelpHeading") }}</h4>
          <p class="after-first-attraction-help-text mb-0">
            {{ t("afterFirstAttractionHelpText") }}
          </p>
        </div>

        <div class="after-first-attraction-tip">
          <h4 class="after-first-attraction-tip-heading">{{ t('afterFirstAttractionTipHeading') }}</h4>
          <p class="after-first-attraction-tip-text mb-0">{{ t('afterFirstAttractionTipText') }}</p>
        </div>
      </div>
    </section>

    <PageFooterNew />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import PageFooterNew from "@/components/PageFooterNew.vue";
import WhatsappChet from "@/components/WhatsappChet";
import { translationMixin } from "@/mixins/translationMixin";

export default {
  name: "AfterFirstAttraction",
  mixins: [translationMixin],
  components: {
    NavBar,
    PageFooterNew,
    WhatsappChet,
  },
  mounted() {
    localStorage.setItem('onboardingActive', '1');
  },
  computed: {
    pageLanguage() {
      return this.getCurrentLanguage === "he" ? "he" : "en";
    },
    pageDirection() {
      return this.getCurrentLanguage === "he" ? "rtl" : "ltr";
    },
    rideId() {
      return this.$route.params.rideId;
    },
  },
  methods: {
    goToRide() {
      if (this.rideId) {
        localStorage.setItem("workAroundToSetTheScroleLocationAtTheMAinPage", "0");
        this.$router.push({ path: "/single_ride_with_map/" + this.rideId, query: { scrollToDay: "0" } });
      } else {
        this.$router.push("/user_rides");
      }
    },
    goToRideAtTop() {
      if (this.rideId) {
        localStorage.setItem("workAroundToSetTheScroleLocationAtTheMAinPage", "0");
        this.$router.push({ path: "/single_ride_with_map/" + this.rideId, query: { showShareHint: "1" } });
      } else {
        this.$router.push("/user_rides");
      }
    },
  },
};
</script>

<style scoped>
.internal-bady {
  line-height: 1.5;
}

.after-first-attraction-section {
  padding-top: 120px;
  padding-bottom: 4rem;
}

.after-first-attraction-success-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 2rem;
  margin-bottom: 1.5rem;
  background: linear-gradient(135deg, rgba(52, 208, 182, 0.2), rgba(7, 160, 195, 0.2));
  border-radius: 16px;
  border: 2px solid rgba(7, 160, 195, 0.4);
}

.after-first-attraction-success-icon {
  font-size: 3.2rem;
  color: #07A0C3;
  flex-shrink: 0;
}

.after-first-attraction-success {
  font-size: 2.6rem;
  font-weight: 800;
  text-align: center;
  color: #0D2F29;
  margin: 0;
}

.after-first-attraction-subtitle {
  font-size: 2rem;
  font-weight: 600;
  text-align: center;
  color: #1e1e1e;
  margin-bottom: 2rem;
  line-height: 1.6;
}

.after-first-attraction-option-card {
  padding: 2rem;
  height: 100%;
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(7, 160, 195, 0.12);
  display: flex;
  flex-direction: column;
}

.after-first-attraction-option-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #0D2F29;
  margin-bottom: 1rem;
}

.after-first-attraction-option-text {
  font-size: 1.5rem;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.6;
  flex-grow: 1;
  white-space: pre-line;
}

/* English: left-align card copy, help, and tip (dir alone can leave blocks visually right-aligned) */
.after-first-attraction--en .after-first-attraction-option-title,
.after-first-attraction--en .after-first-attraction-option-text,
.after-first-attraction--en .after-first-attraction-help-heading,
.after-first-attraction--en .after-first-attraction-help-text,
.after-first-attraction--en .after-first-attraction-tip-heading,
.after-first-attraction--en .after-first-attraction-tip-text {
  text-align: left;
}

.after-first-attraction-tip {
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background: #f8f9fa;
  border-radius: 12px;
  border-right: 4px solid #07A0C3;
}

[dir="ltr"] .after-first-attraction-tip {
  border-right: none;
  border-left: 4px solid #07A0C3;
}

.after-first-attraction-tip-heading {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0D2F29;
  margin-bottom: 0.5rem;
}

.after-first-attraction-tip-text {
  font-size: 1.5rem;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.65;
}

.after-first-attraction-help {
  margin-top: 2rem;
  padding: 1.5rem 2rem;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(7, 160, 195, 0.08);
}

.after-first-attraction-help-heading {
  font-size: 1.6rem;
  font-weight: 700;
  color: #0D2F29;
  margin-bottom: 0.5rem;
}

.after-first-attraction-help-text {
  font-size: 1.5rem;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 1.65;
}

.after-first-attraction-cta {
  padding: 18px 48px;
  font-size: 2.2rem !important;
  border-radius: 14px !important;
  background: linear-gradient(45deg, #34D0B6, #07A0C3);
  color: white;
  border: 0;
}

.after-first-attraction-cta:hover {
  background: linear-gradient(45deg, #39e1c5, #08add3);
  color: white;
}

.after-first-attraction-cta-outline {
  padding: 18px 48px;
  font-size: 2.2rem !important;
  border-radius: 14px !important;
  border: 2px solid #07A0C3;
  color: #07A0C3;
  background: transparent;
}

.after-first-attraction-cta-outline:hover {
  background: rgba(7, 160, 195, 0.1);
  color: #07A0C3;
  border-color: #07A0C3;
}

@media (max-width: 575.98px) {
  .after-first-attraction-section {
    padding-top: 96px;
  }

  .after-first-attraction-option-card .after-first-attraction-cta,
  .after-first-attraction-option-card .after-first-attraction-cta-outline {
    width: 100%;
  }
}
</style>
